<template>
  <div class="quick-edit-container">
    <div class="quick-edit-buttons">
      <button 
        class="quick-edit-btn course-btn"
        @click="handleQuickEditCourses"
      >
        <i class="fas fa-book"></i>
        Quick Edit Course(s)
      </button>
      
      <button 
        class="quick-edit-btn lesson-btn"
        @click="handleQuickEditLessons"
      >
        <i class="fas fa-chalkboard-teacher"></i>
        Quick Edit Lesson(s)
      </button>
    </div>

    <QuickEditCourse 
      v-if="showCourseEditor"
      @edit-course="handleEditCourse"
    />
  </div>
</template>

<script>
import QuickEditCourse from './QuickEditCourse.vue'

export default {
  name: 'QuickEdit',
  components: {
    QuickEditCourse
  },
  data() {
    return {
      showCourseEditor: false
    }
  },
  methods: {
    handleQuickEditCourses() {
      this.showCourseEditor = true;
    },
    handleQuickEditLessons() {
      this.$emit('quick-edit-lessons')
    },
    handleEditCourse(course) {
      this.$emit('edit-course', course)
    }
  }
}
</script>

<style scoped>
.quick-edit-container {
  padding: 1rem;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.quick-edit-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.quick-edit-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.quick-edit-btn i {
  font-size: 1.1rem;
}

.course-btn {
  background-color: #4CAF50;
  color: white;
}

.course-btn:hover {
  background-color: #45a049;
}

.lesson-btn {
  background-color: #2196F3;
  color: white;
}

.lesson-btn:hover {
  background-color: #1976D2;
}
</style> 